module.exports = __webpack_public_path__ + "img/9.f9ca2663.jpg";